<template>
    <div>
        <select-input
            v-model="selectedUser"
            :options="availableUsers"
            :name="name"
            :placeholder="placeholder"
            :filter-function="applySearchFilter"
            :required="required"
        >
            <slot />
        </select-input>
    </div>
</template>

<script>
    export default {
        props: {
            initialSelectedUser: {
                type: Number,
                default: null,
            },
            availableUsers: {
                type: Object,
                required: true,
            },
            placeholder: {
                type: String,
                default: 'Välj användare',
            },
            name: {
                required: true,
                type: String,
            },
            required: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                selectedUser: this.initialSelectedUser || '',
            };
        },
        watch: {
            selectedUser: {
                immediate: true,
                handler(newValue) {
                    this.$emit('input', newValue);
                },
            },
        },
        methods: {
            applySearchFilter(search, users) {
                users = Object.keys(users).map(function (key) {
                    return users[key];
                });

                return users.filter((user) => {
                    return user
                        .toLowerCase()
                        .startsWith(search.toLowerCase());
                });
            },
        },
    };
</script>